import { render, staticRenderFns } from "./DiseasesCreate.vue?vue&type=template&id=6b3a76ac&scoped=true"
import script from "./DiseasesCreate.vue?vue&type=script&lang=js"
export * from "./DiseasesCreate.vue?vue&type=script&lang=js"
import style0 from "./DiseasesCreate.vue?vue&type=style&index=0&id=6b3a76ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3a76ac",
  null
  
)

export default component.exports